import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['regionField', 'regionChosen', 'regionError', 'regionHelper'];
  static values = { regionUrl: String };

  disconnect() {
    this.cancelLookup();
  }

  refresh(event) {
    if (event?.target?.name === 'fee_estimate[region]' && !this.autofilling) {
      this.regionChosenByUser = this.field('region') !== '';
      if (this.regionChosenByUser) this.toggleRegionError(false);
    }

    const completed = [];
    if (this.field('postcode') || this.field('region')) completed.push('location');
    if (this.field('property_type_id')) completed.push('property_type');
    if (/\d/.test(this.field('estimated_value'))) completed.push('value');

    this.element
      .querySelector('[data-controller~="refined-nova--field-progress"]')
      ?.setAttribute('data-refined-nova--field-progress-completed-value', JSON.stringify(completed));
  }

  lookupRegion() {
    this.cancelLookup();
    this.lookupTimeout = setTimeout(() => this.fetchRegion(), 300);
  }

  async fetchRegion() {
    const postcode = this.compactPostcode();
    if (this.regionChosenByUser || postcode.length < 5) return;

    this.lookupRequest = new AbortController();
    const url = new URL(this.regionUrlValue, window.location.origin);
    url.searchParams.set('postcode', postcode);

    let result;
    try {
      const response = await fetch(url, {
        headers: { Accept: 'application/json' },
        signal: this.lookupRequest.signal,
      });
      if (!response.ok) return;
      result = await response.json();
    } catch {
      return;
    }

    if (this.regionChosenByUser || this.compactPostcode() !== postcode) return;

    if (result.region) {
      this.autofillRegion(result.region);
      this.toggleRegionError(false);
    } else if (result.valid) {
      this.autofillRegion('');
      this.toggleRegionError(true);
    }
  }

  cancelLookup() {
    clearTimeout(this.lookupTimeout);
    this.lookupRequest?.abort();
    this.lookupRequest = null;
  }

  autofillRegion(region) {
    const element = this.regionFieldTarget.querySelector('[data-controller~="single-select-field"]');
    const select = this.application.getControllerForElementAndIdentifier(element, 'single-select-field');
    if (!select) return;

    this.autofilling = true;
    if (region) select.setValue(region);
    else if (this.field('region')) select.clearSelection();
    this.autofilling = false;
  }

  toggleRegionError(show) {
    this.regionErrorTarget.classList.toggle('hidden', !show);
    if (this.hasRegionHelperTarget) this.regionHelperTarget.classList.toggle('hidden', show);
  }

  get regionChosenByUser() {
    return this.regionChosenTarget.value === '1';
  }

  set regionChosenByUser(chosen) {
    this.regionChosenTarget.value = chosen ? '1' : '0';
  }

  compactPostcode() {
    return this.field('postcode').replace(/\s+/g, '').toUpperCase();
  }

  field(name) {
    return (this.element.elements.namedItem(`fee_estimate[${name}]`)?.value || '').trim();
  }
}
